<footer id="footer">
    <a mat-button (click)="openModalContact()">{{'general.contact'|translate}}</a> <span class="space">| </span>
    <a mat-button (click)="openModal('mentions_legales')">
        {{ 'general.mentionsLegales' | translate}}
    </a>
    <span class="space">| </span>
    <a mat-button (click)="openModal('document_politique_protection_donnees')">
        {{'general.politiqueConfidentialite'|translate}}
    </a>
</footer>
<div id="spacer-footer"></div>
